export default function DSA_Linked_Lists_Types() {
  return <div>DSA_Linked_Lists_Types Component</div>;
}
